export default "__VITE_ASSET__BaDWF18m__"